module.exports = __webpack_public_path__ + "img/uniform-martial-arts.903cd7a4.svg";